import React from "react";
import Input from "../../../../components/FormComponents/Input";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditDateRangeField = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("block_past_date")}
          checked={editFieldData.block_past_date}
          name="block_past_date"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("block_future_date")}
          checked={editFieldData.block_future_date}
          name="block_future_date"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("prefill_current")}
          checked={editFieldData.prefill_current}
          name="prefill_current"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("backend_validation")}
        checked={editFieldData.validate.backend_validation}
        name="backend_validation"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
      />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("minDays")}
          type="number"
          value={editFieldData.validate.minDays}
          name="minDays"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
        />
        <Input
          label={getLabelForKey("maxDays")}
          type="number"
          value={editFieldData.validate.maxDays}
          name="maxDays"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditDateRangeField;
